import React from "react";
import moment from "moment";
import "moment/locale/pt-br";
import { fieldControlBase } from "./inputTheme";

const LastMonthsSelect = ({ onChange, className, value }) => {
  const generateLastTenMonths = () => {
    const months = [];
    for (let i = 0; i < 10; i++) {
      const month = moment().subtract(i, "months");
      months.push({
        display: month.format("MMMM/YY"),
        value: month.format("YYYY-MM"),
      });
    }
    return months;
  };

  const lastTenMonths = generateLastTenMonths();

  return (
    <select
      onChange={onChange}
      className={`${
        className || `md:w-fit`
      } ${fieldControlBase} capitalize`}
      value={value}
    >
      {lastTenMonths.map((month, index) => (
        <option key={index} value={month.value}>
          {month.display}
        </option>
      ))}
    </select>
  );
};

export default LastMonthsSelect;
